import React from 'react';
export function Footer() {
  return <footer className="w-full bg-textDark text-secondary py-16 px-4" data-id="element-53">
      <div className="max-w-6xl mx-auto" data-id="element-54">
        <div className="text-center mb-12" data-id="element-55">
          <h3 className="font-heading font-bold text-3xl mb-4 text-white" data-id="element-56">
            🧶 MÉTODO CREA CON HILOS
          </h3>
          <p className="font-body text-secondary/70 text-lg italic" data-id="element-57">
            Aprende crochet desde cero y crea piezas hermosas
          </p>
        </div>

        <div className="border-t border-secondary/20 pt-8 text-center" data-id="element-58">
          <p className="font-body text-sm text-secondary/50 mb-6" data-id="element-59">
            © {new Date().getFullYear()} Método Crea con Hilos. Todos los
            derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-sm font-body" data-id="element-60">
            <a href="#" className="text-secondary/70 hover:text-white transition-colors" data-id="element-61">
              Términos y Condiciones
            </a>
            <a href="#" className="text-secondary/70 hover:text-white transition-colors" data-id="element-62">
              Política de Privacidad
            </a>
            <a href="#" className="text-secondary/70 hover:text-white transition-colors" data-id="element-63">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}